import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Loader from '../../../components/Loader';
import { Box, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from "yup";
import CommonButtonVoucherForm from '../../../shared-components/common-button/CommonButtonVoucherForm';
import {
    setActiveStep, setApplicantActiveStep, setEditPreviewApplicant, setReviewActiveStep,
    setStepsCompleted,
    updateApplicantDetailsForm,
} from "../voucher-form.slice";
import { route } from '../../../services/apiRoutes';
import { CAMPAIGN_LIST_STATUS_OPTIONS, FORM_PHASE, formatIndianCurrencyShort } from '../../../config/constant';
import {
    getVoucherAmount,
    getStdEoiAmount,
    getPreEoiAmount,
    hasVoucherAmount,
    hasStdEoiAmount,
    hasPreEoiAmount,
} from './common-functions/EoiAmountHelpers';


const EoiUnitPreference = () => {
    const dispatch = useDispatch();
    const { voucherId } = useParams();

    const { applicantData, activeStep, isLoading, stepsCompleted,eoiCampaignDetails } = useSelector(
        (state) => state?.voucherForm
        
    );
    const isVoucherPhase = applicantData?.formPhase === FORM_PHASE.VOUCHER;

    const showVoucher = [CAMPAIGN_LIST_STATUS_OPTIONS.ACTIVE_VOUCHER, CAMPAIGN_LIST_STATUS_OPTIONS.ACTIVE_VOUCHER_AND_EOI]
    const showEOI = [CAMPAIGN_LIST_STATUS_OPTIONS.ACTIVE_EOI, CAMPAIGN_LIST_STATUS_OPTIONS.ACTIVE_VOUCHER_AND_EOI, CAMPAIGN_LIST_STATUS_OPTIONS.ACTIVE_VOUCHER_TO_EOI ]

    const isEOIValid = showEOI.includes(eoiCampaignDetails?.status)
    // For Active | Voucher and Active | Voucher and EOI: show voucher option only when applicant has no voucherId yet
    const shouldShowVoucherOption = showVoucher?.includes(eoiCampaignDetails?.status) && !applicantData?.paidVoucherId 

    const indicativeBasePrice = eoiCampaignDetails?.indicativeBasePrice;
    const unitPreferenceFormik = useFormik({
        initialValues: {
            typologyPreference: "",
            eoiPreference: "",
            // tower1: "",
            // floor1: "",
            // series1: "",
            // unit1: "",
            // tower2: "",
            // floor2: "",
            // series2: "",
            // unit2: "",
            // tower3: "",
            // floor3: "",
            // series3: "",
            // unit3: "",
        },
        validationSchema: yup.object().shape({
            typologyPreference: yup.string().required("Unit Preference is required"),
            eoiPreference: yup.string().required(`${isVoucherPhase ? "Voucher" : "EOI"} Preference is required`),
            // tower1: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Tower is required")
            //         : yup.array().notRequired();
            // }),
            // floor1: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Floor is required")
            //         : yup.array().notRequired();
            // }),
            // series1: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Series is required")
            //         : yup.array().notRequired();
            // }),
            // unit1: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Unit is required")
            //         : yup.array().notRequired();
            // }),
            // tower2: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Tower is required")
            //         : yup.array().notRequired();
            // }),
            // floor2: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Floor is required")
            //         : yup.array().notRequired();
            // }),
            // series2: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Series is required")
            //         : yup.array().notRequired();
            // }),
            // unit2: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Unit is required")
            //         : yup.array().notRequired();
            // }),
            // tower3: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Tower is required")
            //         : yup.array().notRequired();
            // }),
            // floor3: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Floor is required")
            //         : yup.array().notRequired();
            // }),
            // series3: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Series is required")
            //         : yup.array().notRequired();
            // }),
            // unit3: yup.string().when("eoiPreference", (ll, schema) => {
            //     return unitPreferenceFormik.values.eoiPreference === "Preferential"
            //         ? yup
            //             .string()
            //             .required("Unit is required")
            //         : yup.array().notRequired();
            // }),
        }),
    });

    useEffect(() => {
        if (applicantData?.eoiDetails) {
            const { eoiDetails } = applicantData;

            unitPreferenceFormik.setValues({
                typologyPreference: eoiDetails?.typology || "",
                eoiPreference: eoiDetails?.eoiType || "",
                // // Preference 1
                // tower1: eoiDetails?.preferences?.[0]?.tower || "",
                // floor1: eoiDetails?.preferences?.[0]?.floor || "",
                // series1: eoiDetails?.preferences?.[0]?.series || "",
                // unit1: eoiDetails?.preferences?.[0]?.unit || "",

                // // Preference 2
                // tower2: eoiDetails?.preferences?.[1]?.tower || "",
                // floor2: eoiDetails?.preferences?.[1]?.floor || "",
                // series2: eoiDetails?.preferences?.[1]?.series || "",
                // unit2: eoiDetails?.preferences?.[1]?.unit || "",

                // // Preference 3
                // tower3: eoiDetails?.preferences?.[2]?.tower || "",
                // floor3: eoiDetails?.preferences?.[2]?.floor || "",
                // series3: eoiDetails?.preferences?.[2]?.series || "",
                // unit3: eoiDetails?.preferences?.[2]?.unit || "",
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applicantData, applicantData?.eoiDetails]);

    useEffect(() => {
        const inventory = eoiCampaignDetails?.inventoryDetails || [];
        const firstTypology = inventory[0]?.type;
        const hasNoSavedData = !applicantData?.eoiDetails;
        const typologyEmpty = !unitPreferenceFormik.values?.typologyPreference;
        const eoiPreferenceEmpty = !unitPreferenceFormik.values?.eoiPreference;

        if (hasNoSavedData) {
            if (firstTypology && typologyEmpty) {
                unitPreferenceFormik.setFieldValue("typologyPreference", firstTypology);
            }
            if (eoiPreferenceEmpty) {
                const isValidVoucher = isVoucherPhase && shouldShowVoucherOption && hasVoucherAmount(eoiCampaignDetails)
                
                const firstEoi = (isValidVoucher) ? "Voucher"
                    : (isEOIValid && hasStdEoiAmount(eoiCampaignDetails)) ? "Standard"
                        : (isEOIValid && hasPreEoiAmount(eoiCampaignDetails)) ? "Preferential" : null;
                if (firstEoi) {
                    unitPreferenceFormik.setFieldValue("eoiPreference", firstEoi);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eoiCampaignDetails?.inventoryDetails, applicantData?.eoiDetails]);

    useEffect(() => {
        unitPreferenceFormik.validateForm()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unitPreferenceFormik?.values])

    const handlePrevious = () => {
        dispatch(setActiveStep(activeStep - 1))
    }

    // Helper function to create the other details payload
    const createUnitPreferencePayload = (saveForLaterFlag = false) => {
        const { values } = unitPreferenceFormik;
        const payload = {
            saveForLater: saveForLaterFlag,
            typology: values?.typologyPreference || "",
            eoiType: values?.eoiPreference || "",
        };
        // if (values?.eoiPreference === "Preferential") {
        //     payload.preferences = [
        //         {
        //             tower: values?.tower1 || "",
        //             floor: values?.floor1 || "",
        //             series: values?.series1 || "",
        //             unit: values?.unit1 || "",
        //         },
        //         {
        //             tower: values?.tower2 || "",
        //             floor: values?.floor2 || "",
        //             series: values?.series2 || "",
        //             unit: values?.unit2 || "",
        //         },
        //         {
        //             tower: values?.tower3 || "",
        //             floor: values?.floor3 || "",
        //             series: values?.series3 || "",
        //             unit: values?.unit3 || "",
        //         },
        //     ];
        // }
        return payload;
    };

    const handleSaveForm = (type) => {
        if (Object.keys(unitPreferenceFormik.errors).length === 0) {
            const payload = {
                ...createUnitPreferencePayload(type === "saveForLater"),
                lastStep:activeStep+1,
            };
            dispatch(setReviewActiveStep(0));
            dispatch(
                updateApplicantDetailsForm({
                    path: `${route.UPDATE_EOI_DETAILS}/${voucherId}`,
                    payload: payload,
                    opportunityId: voucherId
                })
            )
                .unwrap()
                .then((res) => {
                    if (res?.status === 200) {
                        let completedSteps = {
                            ...stepsCompleted,
                            [activeStep]: true,
                        };
                        dispatch(setEditPreviewApplicant(false));
                        dispatch(setStepsCompleted(completedSteps));
                        dispatch(setApplicantActiveStep(0));
                        dispatch(setActiveStep(activeStep + 1));
                    }
                }
                );
        }
    };
            
    const columnVisibility = useMemo(() => {
        const inventory = eoiCampaignDetails?.inventoryDetails || [];
        let hasArea = false;
        let hasPrice = false;

        for (const item of inventory) {
            if (item?.minSBA || item?.maxSBA) hasArea = true;
            if (item?.minPrice || item?.maxPrice) hasPrice = true;
            if (hasArea && hasPrice) break;
        }

        return {
            showArea: hasArea,
            showPrice: hasPrice,
        };
    }, [eoiCampaignDetails?.inventoryDetails]);

  const usePlotsUnitTableData = () => {

  const PLOTS_UNIT_TABLE_DATA = useMemo(() => {
    const inventory = eoiCampaignDetails?.inventoryDetails || [];

    const tableData = inventory?.map((item) => {
      const { type, minSBA, maxSBA, minPrice, maxPrice } = item;

        return {
            typology: type || "",
            minSBA,
            maxSBA,
            minPrice,
            maxPrice,
            value: type || "",
        };
    });

    return tableData;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eoiCampaignDetails]);

  return PLOTS_UNIT_TABLE_DATA;
};

    const selectedTypology = unitPreferenceFormik.values?.typologyPreference;
    const isVoucherValidWithAmount = shouldShowVoucherOption && hasVoucherAmount(eoiCampaignDetails) && isVoucherPhase;
    const isEOIValidWithStdAmount = isEOIValid && hasStdEoiAmount(eoiCampaignDetails);
    const isEOIValidWithPreAmount = isEOIValid && hasPreEoiAmount(eoiCampaignDetails);

    const getAmountDisplay = (amount, label) => {
        return amount != null ? `₹${formatIndianCurrencyShort(amount)} (${label})` : `₹0 (${label})`;
    };

    const EOI_TABLE_DATA = useMemo(() => [
        isVoucherValidWithAmount && {
            eoi: "Voucher",
            amount: getAmountDisplay(getVoucherAmount(eoiCampaignDetails, selectedTypology), "Voucher Value"),
            advantage: "Unit Select based on availability",
        },
        isEOIValidWithStdAmount && {
            eoi: "Standard",
            amount: getAmountDisplay(getStdEoiAmount(eoiCampaignDetails, selectedTypology), "EOI Value"),
            advantage: "Unit Select based on availability",
        },
        isEOIValidWithPreAmount && {
            eoi: "Preferential",
            amount: getAmountDisplay(getPreEoiAmount(eoiCampaignDetails, selectedTypology), "EOI Value"),
            advantage: "1st Preference & Spot Allocation",
        },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ].filter(Boolean), [
        eoiCampaignDetails,
        unitPreferenceFormik.values?.typologyPreference,
        isVoucherValidWithAmount,
        isEOIValidWithStdAmount,
        isEOIValidWithPreAmount,
    ]);

    // When current selection is not in the visible list: prefer saved eoiDetails.eoiType (Pref/Std/Voucher) if still visible, else first visible.
    useEffect(() => {
        if (!EOI_TABLE_DATA?.length) return;
        const currentValue = unitPreferenceFormik.values?.eoiPreference;
        const isCurrentValueVisible = EOI_TABLE_DATA.some((row) => row.eoi === currentValue);
        if (isCurrentValueVisible) return;

        const savedEoiType = applicantData?.eoiDetails?.eoiType;
        const savedTypeStillVisible = savedEoiType && EOI_TABLE_DATA.some((row) => row.eoi === savedEoiType);
        const valueToSet = savedTypeStillVisible ? savedEoiType : EOI_TABLE_DATA[0]?.eoi;
        if (valueToSet) {
            unitPreferenceFormik.setFieldValue("eoiPreference", valueToSet);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [EOI_TABLE_DATA, applicantData?.voucherId, applicantData?.eoiDetails, applicantData?.paidVoucherId]);

    const getPriceDisplay = (minPrice, maxPrice) => {
        if (!minPrice && !maxPrice) return "On Request";

        let result = "";

        if (minPrice) {
            result += `₹${formatIndianCurrencyShort(minPrice)}`;
        }

        if (minPrice && maxPrice) {
            result += " - ";
        }

        if (maxPrice) {
            result += `₹${formatIndianCurrencyShort(maxPrice)}`;
        }

        return result;
    };

    const getAreaDisplay = (minSBA, maxSBA) => {
        if (!minSBA && !maxSBA) return "On Request";

        let result = "";

        if (minSBA) {
            result += `${minSBA}`;
        }

        if (minSBA && maxSBA) {
            result += " - ";
        }

        if (maxSBA) {
            result += `${maxSBA}`;
        }

        return `${result} Sq.ft.`;
    };

    const preferenceColStyle = {
      width: { xs: 100, sm: 150 },
      minWidth: { xs: 100, sm: 150 },
      maxWidth: { xs: 100, sm: 150 },
    };

    return (
        <div>
            {isLoading && <Loader isLoading={isLoading} />}
            <Typography
                sx={{
                    color: "#1C252E",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "36px",
                    mb: "12px",
                    textAlign: "center",
                }}
            >
                Unit Preference
            </Typography>

            <form
                onSubmit={unitPreferenceFormik.handleSubmit}
                onReset={unitPreferenceFormik.handleReset}
            >
                <TableContainer sx={{ overflowX: "auto" }}>
                    <Table
                        sx={{
                            width: "100%",
                            tableLayout: "auto",
                            '& td, & th': {
                                border: '1px solid #E0E0E0',
                            },
                        }}>
                        <TableHead>
                            {(!!indicativeBasePrice) && (
                                <TableRow>
                                    <TableCell
                                        colSpan={
                                            2 +
                                            (columnVisibility.showArea ? 1 : 0) +
                                            (columnVisibility.showPrice ? 1 : 0)
                                        }
                                        sx={{ textAlign: "center", fontWeight: 500, fontSize: "12px" }}
                                    >
                                        Indicative Base Price-₹{indicativeBasePrice} per Sq. ft
                                    </TableCell>
                                </TableRow>
                            )}
                            <TableRow>
                                {/* Fixed Column */}
                                <TableCell sx={preferenceColStyle}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        My/ Our Preference
                                    </Typography>
                                </TableCell>

                                {/* Flexible Column */}
                                <TableCell>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        Typology
                                    </Typography>
                                </TableCell>

                                {/* Conditional Area */}
                                {columnVisibility.showArea && (
                                    <TableCell>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                            Indicative Saleable Area
                                        </Typography>
                                    </TableCell>
                                )}

                                {/* Conditional Price */}
                                {columnVisibility.showPrice && (
                                    <TableCell>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                            Indicative Unit Price
                                        </Typography>
                                    </TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(usePlotsUnitTableData() ?? [])?.map((row, index) => (
                                <TableRow key={index}>
                                    {/* Fixed radio column */}
                                    <TableCell
                                        sx={{
                                            ...preferenceColStyle,
                                            padding: '7px',
                                            textAlign: 'center'
                                        }}
                                    >
                                        <Radio
                                            checked={unitPreferenceFormik.values.typologyPreference === row?.value}
                                            onChange={() =>
                                                unitPreferenceFormik.setFieldValue("typologyPreference", row?.value)
                                            }
                                            value={row.value}
                                        />
                                    </TableCell>

                                    {/* Typology */}
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 500 }}>
                                        {row?.typology}
                                    </TableCell>

                                    {/* Area */}
                                    {columnVisibility.showArea && (
                                        <TableCell sx={{ fontSize: '12px', fontWeight: 500 }}>
                                            {getAreaDisplay(row.minSBA, row.maxSBA)}
                                        </TableCell>
                                    )}

                                    {/* Price */}
                                    {columnVisibility.showPrice && (
                                        <TableCell sx={{ fontSize: '12px', fontWeight: 500 }}>
                                            {getPriceDisplay(row.minPrice, row.maxPrice)}
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {unitPreferenceFormik.touched.typologyPreference && unitPreferenceFormik.errors.typologyPreference && (
                        <Typography sx={{ color: "red", fontSize: "12px", mt: 1 }}>
                            {unitPreferenceFormik.errors.typologyPreference}
                        </Typography>
                    )}
                </TableContainer>

                <Box
                    className="rich-text"
                    sx={{ minHeight: 25 }}
                    dangerouslySetInnerHTML={{ __html: eoiCampaignDetails?.unitPrefStaticContent }}
                />

                <TableContainer sx={{ overflowX: "auto", mb: 3 }}>
                    <Table
                        sx={{
                            '& td, & th': {
                                border: '1px solid #E0E0E0',
                            },
                        }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: "17%" }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        My/ Our Preference
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ width: "26%" }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        {isVoucherPhase ? "Voucher Type" : "EOI Type"}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ width: "26%" }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        Amount
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ width: "26%" }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        Advantage
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {EOI_TABLE_DATA.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell sx={{ padding: '7px', textAlign: "center" }}>
                                        <Radio
                                            checked={unitPreferenceFormik.values.eoiPreference === row.eoi}
                                            onChange={() => unitPreferenceFormik.setFieldValue("eoiPreference", row.eoi)}
                                            value={row.eoi}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 500 }}>{row.eoi}</TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 500 }}>{row.amount}</TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 500 }}>{row.advantage}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {unitPreferenceFormik.touched.eoiPreference && unitPreferenceFormik.errors.eoiPreference && (
                        <Typography sx={{ color: "red", fontSize: "12px", mt: 1 }}>
                            {unitPreferenceFormik.errors.eoiPreference}
                        </Typography>
                    )}
                </TableContainer>

                {/* {unitPreferenceFormik.values.eoiPreference === "Preferential" && (
                    <>
                        <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>Select Preference 1</Typography>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "tower1",
                                        label: "Tower",
                                        required: true,
                                        readonly: false,
                                        options: TOWER_OPTIONS,
                                        placeholder: "Select Tower"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "floor1",
                                        label: "Floor",
                                        required: true,
                                        readonly: false,
                                        options: FLOOR_OPTIONS,
                                        placeholder: "Select Floor"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "series1",
                                        label: "Series",
                                        required: true,
                                        readonly: false,
                                        options: SERIES_OPTIONS,
                                        placeholder: "Select Series"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "unit1",
                                        label: "Unit",
                                        required: true,
                                        readonly: false,
                                        options: UNIT_OPTIONS,
                                        placeholder: "Select Unit"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                        </Grid>
                        <Divider sx={{ mt: 2, border: '1px dashed #DADADA' }} />

                        <Typography mt={2} sx={{ fontSize: '14px', fontWeight: 600 }}>Select Preference 2</Typography>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "tower2",
                                        label: "Tower",
                                        required: true,
                                        readonly: false,
                                        options: TOWER_OPTIONS,
                                        placeholder: "Select Tower"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "floor2",
                                        label: "Floor",
                                        required: true,
                                        readonly: false,
                                        options: FLOOR_OPTIONS,
                                        placeholder: "Select Floor"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "series2",
                                        label: "Series",
                                        required: true,
                                        readonly: false,
                                        options: SERIES_OPTIONS,
                                        placeholder: "Select Series"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "unit2",
                                        label: "Unit",
                                        required: true,
                                        readonly: false,
                                        options: UNIT_OPTIONS,
                                        placeholder: "Select Unit"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                        </Grid>
                        <Divider sx={{ mt: 2, border: '1px dashed #DADADA' }} />

                        <Typography mt={2} sx={{ fontSize: '14px', fontWeight: 600 }}>Select Preference 3</Typography>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "tower3",
                                        label: "Tower",
                                        required: true,
                                        readonly: false,
                                        options: TOWER_OPTIONS,
                                        placeholder: "Select Tower"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "floor3",
                                        label: "Floor",
                                        required: true,
                                        readonly: false,
                                        options: FLOOR_OPTIONS,
                                        placeholder: "Select Floor"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "series3",
                                        label: "Series",
                                        required: true,
                                        readonly: false,
                                        options: SERIES_OPTIONS,
                                        placeholder: "Select Series"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <SelectInput
                                    field={{
                                        name: "unit3",
                                        label: "Unit",
                                        required: true,
                                        readonly: false,
                                        options: UNIT_OPTIONS,
                                        placeholder: "Select Unit"
                                    }}
                                    formik={unitPreferenceFormik}
                                />
                            </Grid>
                        </Grid>
                        <Divider sx={{ mt: 2, border: '1px dashed #DADADA' }} />
                    </>
                )} */}

                <CommonButtonVoucherForm
                    handleNext={handleSaveForm}
                    // isDisable={isDisable}
                    handlePrevious={handlePrevious}
                    saveDraftPath={`${route.UPDATE_EOI_DETAILS}/${voucherId}`}
                    saveDraftData={{
                        ...createUnitPreferencePayload(true),
                        lastStep: applicantData?.lastStep > activeStep
                            ? applicantData?.lastStep
                            : activeStep,
                    }}
                />
            </form>
        </div>
    )
}

export default EoiUnitPreference